export default function ({ router, i18n }) {

  function legacyRouterMode ({ fullPath }, from, next) {
    if (fullPath.substr(0, 2) === '/#') {
      const path = fullPath.substr(2)
      next(path)
      return
    }
    next()
  }

  function skipHome(to, from, next) {
    if (to.name === 'home') {
      const locale = i18n.locale
      return next({ name: 'list', params: { locale } })
    }

    if (to.name === 'acerca' || to.name === 'perfil') {

      window.scrollTo(0,0)

      return next()
    }
    return next()
  }

  router.beforeEach(legacyRouterMode)
  router.beforeEach(skipHome)

  return router
}
